/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReportCategoryDto } from '../../models/report-category-dto';

export interface ReportCategoryGetByRoleId$Params {
}

export function reportCategoryGetByRoleId(http: HttpClient, rootUrl: string, params?: ReportCategoryGetByRoleId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ReportCategoryDto>>> {
  const rb = new RequestBuilder(rootUrl, reportCategoryGetByRoleId.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ReportCategoryDto>>;
    })
  );
}

reportCategoryGetByRoleId.PATH = '/api/ReportCategory/reportcategories/listByRoleID';
